export default __webpack_public_path__ + "static/media/polaroid16.9cc7ddcf.jpg";